import Vue from 'vue'
import App from './App.vue'
import router from './router'

import 'normalize.css'

import * as api from './service/api'
import * as filters from './filters' // global filters

Vue.config.productionTip = false

// register global utility filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.prototype.$api = api

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
